import { get, includes } from 'lodash';
import { config } from '@/services/config';
import { PortfolioStatus } from '@/enums/Global';

export const colorClassToHex = (colorClass: string) => {
  return get(config.layout, `theme.extend.colors[${colorClass}]`, null);
};

export const getServiceColorClass = (serviceLevel: string) => {
  const colorClassList = get(
    config.layout,
    'colours.serviceLevelColours',
    null
  );
  return colorClassList ? colorClassList[serviceLevel] : '';
};

export const getStatusColour = (status: string) => {
  const configStatusIndicators = get(
    config.layout,
    'colours.status.colour',
    {}
  );
  if (includes(PortfolioStatus, status)) {
    return get(configStatusIndicators, status, '');
  }
  return '';
};
